import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-m-file-picker',
  templateUrl: './m-file-picker.component.html',
  styleUrls: ['./m-file-picker.component.css']
})
export class MFilePickerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
